export const GET_LECTURES = 'GET_LECTURES_ELEMENTS';
export const GET_STUDENTS = 'GET_STUDENTS_ELEMENTS';
export const GET_CHAT = 'GET_CHAT_ELEMENT';
export const GET_MESSAGES = 'GET_MESSAGES_ELEMENTS';
